import React, { useRef } from "react"
import Button from "../components/Button"
import Hero from "../components/Hero"
import Layout from "../components/Layout"
import Title from "../components/Title"
import { Icon1, Icon2, Icon3, Icon4, Icon5, Icon6 } from "../components/Icons"
import gsap from "gsap"

const Card = ({ Icon, title, text }) => {
  return (
    <div className="text-center w-full flex flex-col gap-8 max-w-xs items-center">
      <Icon />
      <div className="text-2xl font-bold">{title}</div>
      <div className="text-base sm:text-lg ">{text}</div>
    </div>
  )
}

const WWD = () => {
  return (
    <div className="flex flex-col">
      <Title>What We Do</Title>
      <div className="flex flex-wrap gap-20 justify-center w-full">
        <Card
          title="Design"
          text="We design user friendly and clean  interfaces for your website "
          Icon={Icon1}
        />
        <Card
          title="Develop"
          text="We develop your website using  best technologies in the field"
          Icon={Icon2}
        />
        <Card
          title="Host"
          text="We make your website open to the world in a best manner"
          Icon={Icon3}
        />
      </div>
    </div>
  )
}
const WWA = () => {
  return (
    <div className="flex flex-col">
      <Title>What We Admire</Title>
      <div className="flex flex-wrap gap-20 justify-center w-full">
        <Card
          title="Uniqueness"
          text="We make it in a most unique way according to the requirements of our client"
          Icon={Icon4}
        />
        <Card
          title="Responsiveness"
          text="We make it fits for all mobile and pc devices without damaging the concept"
          Icon={Icon5}
        />
        <Card
          title="Intimacy"
          text="We make it more client friendly as our clients will have a smily face till the end of project"
          Icon={Icon6}
        />
      </div>
    </div>
  )
}
const SiteCard = ({ title, text, bg }) => {
  const content = useRef()
  return (
   
    <div
      onMouseEnter={()=>{
        gsap.to(content.current,0.3,{
          top:'0%',
        })
        gsap.to(content.current,0.3,{
          top:'0%',
        })
      }}
      onMouseLeave={()=>{
        gsap.to(content.current,0.3,{
          top:'75%',
        })
      }}
      style={{
        
        background: `url(/static/${bg}) center no-repeat`,
        backgroundSize: "cover",
      }}
      className="w-full max-w-sm h-80 overflow-hidden flex flex-col text-center items-center "
    >
      <div style={{top:'75%'}} ref={content} className="w-full h-full text-white backdrop-filter bg-blue   flex flex-col relative items-col ">
        <div  className="text-2xl text-white h-1/4 flex items-center justify-center">{title}</div>
        <div className="text-base sm:text-lg h-3/4 p-8">{text}</div>
      </div>
    </div>
  )
}
const SitesBuilding = () => {
  return (
    <div className="flex flex-col w-full">
      <Title>Some of What We Make</Title>
      <div className="flex flex-wrap justify-center gap-12">
        <SiteCard
          bg="site1.jpg"
          title="Landing Pages"
          text=" A standalone web page, created specifically for the purposes of a marketing or advertising campaign"
        />
        <SiteCard
          bg="site2.jpg"
          title="Contact Pages"
          text=" A web page, where users can connect with you or others including the directories to other sections"
        />
        <SiteCard
          bg="site3.jpg"
          title="Promotional Sites"
          text=" A website where represent the identity of a business on the Internet designed with a combination of above pages"
        />
        <SiteCard
          bg="site4.jpg"
          title="Blog Sites"
          text=" A website that contains personal reflections, comments,  media content provided by the writer"
        />
        <SiteCard
          bg="site5.jpg"
          title="E-commerce Sites"
          text=" An online shopping place where users can purchase products or services from your company"
        />
        <SiteCard
          bg="site6.jpg"
          title="Portfolio Sites"
          text=" An web site where creative professionals showcasing their best work to the world in a fantasy way"
        />
      </div>
    </div>
  )
}
const Chat = () => {
  return (
    <div className="flex flex-col   w-full items-center">
      <Title>Let's Have A Talk</Title>
      <div className="text-base sm:text-lg mb-8 text-center max-w-md">
        We are ready to understand your requirements and guide you on how to
        choose the best solution to meet your business goals.
      </div>
      <a href="tel:+94766743755" className="">
        <Button>Make A Call</Button>
      </a>
    </div>
  )
}
export default function Home({ location }) {
  return (
    <Layout location={location.pathname}>
      <div className="flex flex-col w-full gap-48 max-w-5xl w-full mx-auto text-base sm:text-lg  px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 ">
        <Hero />
        <WWD />
        <SitesBuilding />
        <WWA />
        <Chat />
      </div>
    </Layout>
  )
}
